import {Component, Input} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-table-list-loader',
  styleUrls: ['./table-list-loader.component.scss'],
  template: `
    <table class="table w-100 gy-5 table-row-bordered align-middle">
      <thead>
      <tr>
        <th *ngFor="let i of [0, 1, 2, 3, 4]">
          <app-table-content [width]="80" [height]="20" [isFinishLoadingSubject]="isFinishLoading" />
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of [0, 1, 2]">
        <td *ngFor="let i of [0, 1, 2, 3, 4]">
          <app-table-content [count]="1" [isFinishLoadingSubject]="isFinishLoading" [type]="'text'" />
        </td>
      </tr>
      </tbody>
    </table>
  `
})
export class TableListLoaderComponent {
  @Input() isFinishLoading!:BehaviorSubject<boolean>;

}
